/**
 * This file was automatically generated by toolspec-generator.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSON file,
 * and run toolspec-generator to regenerate this file.
 */
import { Tool } from '@aws-sdk/client-bedrock-runtime'

export const DrawingsSchema: Tool[] = [
  {
    toolSpec: {
      name: 'locate_in_document',
      description:
        'Resolve one indexed engineering drawing and locate exact text, equipment tags, or regex patterns. Returns normalized page regions and a sandbox-local document path for follow-up analysis.',
      inputSchema: {
        json: {
          type: 'object',
          additionalProperties: false,
          properties: {
            source: {
              type: 'string',
              enum: ['docs_hub', 'ingest_corpus'],
              description: 'Document collection containing the drawing.'
            },
            job_id: {
              type: 'string',
              description: 'Required for ingest_corpus; omit for docs_hub.'
            },
            path: {
              type: 'string',
              description: 'Exact source path. Provide either path or drawing_number.'
            },
            drawing_number: {
              type: 'string',
              description:
                'Normalized title-block drawing number. Provide either drawing_number or path.'
            },
            page: {
              type: 'integer',
              minimum: 1,
              description: 'Optional one-based page restriction.'
            },
            pattern: {
              type: 'string',
              minLength: 1,
              maxLength: 500,
              description: 'Text, tag, or regular expression to locate.'
            },
            mode: {
              type: 'string',
              enum: ['literal', 'tag', 'regex'],
              default: 'literal'
            }
          },
          required: ['source', 'pattern', 'mode'],
          oneOf: [
            {
              required: ['path'],
              not: { required: ['drawing_number'] }
            },
            {
              required: ['drawing_number'],
              not: { required: ['path'] }
            }
          ]
        }
      }
    }
  },
  {
    toolSpec: {
      name: 'publish_figure',
      description:
        'Persist a useful sandbox crop as a figure in this chat and return a figure citation. Publish only evidence that supports the answer, with an exact source page and normalized source bounding box.',
      inputSchema: {
        json: {
          type: 'object',
          additionalProperties: false,
          properties: {
            path: {
              type: 'string',
              description: 'Workspace-relative PNG/JPEG crop path.'
            },
            source: {
              type: 'string',
              enum: ['docs_hub', 'ingest_corpus']
            },
            doc_path: {
              type: 'string',
              description: 'Original document path.'
            },
            job_id: {
              type: 'string',
              description: 'Required when source is ingest_corpus.'
            },
            page: {
              type: 'integer',
              minimum: 1
            },
            bbox: {
              type: 'array',
              items: { type: 'number', minimum: 0, maximum: 1 },
              minItems: 4,
              maxItems: 4,
              description: 'Normalized [x0,y0,x1,y1] source region represented by the crop.'
            },
            caption: {
              type: 'string',
              minLength: 1,
              maxLength: 500
            }
          },
          required: ['path', 'source', 'doc_path', 'page', 'bbox', 'caption']
        }
      }
    }
  }
]

export enum DrawingsToolNames {
  LocateInDocument = 'locate_in_document',
  PublishFigure = 'publish_figure'
}
